<it-header
	[slimTitle]="environment.institution"
	slimTitleLink="https://home.provincia.bz.it"
	light="true"
	showSearch="true"
	[sticky]="sticky"
	[megamenu]="true"
	[loginStyle]="!isLogged ? 'default' : 'none'"
	(loginClick)="login.emit()"
	(searchClick)="goToSearch()"
	#headerEl
>
	<ng-container slimRightZone>
		<it-language-switcher
			[availableLanguages]="availableLanguages"
			mode="nav"
		></it-language-switcher>

		@if (isLogged) {
			@if (profile) {
				<it-navbar-item>
					<it-dropdown mode="nav">
						<span button
							><it-icon name="user"></it-icon>
							{{ profile.firstName }} {{ profile.lastName }}
						</span>
						<ng-container list>
							<it-dropdown-item
								><button
									type="button"
									itButton="outline-primary"
									(click)="logout.emit()"
								>
									{{ "iterlex.logout" | translate }}
								</button></it-dropdown-item
							>
						</ng-container>
					</it-dropdown>
				</it-navbar-item>
			}
		}
	</ng-container>
	<ng-container brand>
		<a routerLink="/">
			<img alt="" class="icon" [src]="environment.logoSrc" />
			<div class="it-brand-text">
				<div class="it-brand-title">Iterlex</div>
				<div class="it-brand-tagline d-none d-md-block">
					{{ environment.name }}
				</div>
			</div>
		</a>
	</ng-container>
	<ng-container navItems>
		<it-navbar-item>
			<a
				class="nav-link"
				routerLink="/"
				routerLinkActive="active"
				ariaCurrentWhenActive="page"
				[routerLinkActiveOptions]="{ exact: true }"
				(click)="headerEl.closeNavBar()"
				>{{ "it.navigation.home" | translate }}</a
			>
		</it-navbar-item>
		<it-navbar-item>
			<a
				class="nav-link"
				routerLink="/staging-area"
				routerLinkActive="active"
				ariaCurrentWhenActive="page"
				(click)="headerEl.closeNavBar()"
				>{{ "iterlex.staging-area" | translate }}</a
			>
		</it-navbar-item>
		@if (isAdmin) {
			<it-navbar-item>
				<a
					class="nav-link"
					routerLink="/admin"
					routerLinkActive="active"
					ariaCurrentWhenActive="page"
					(click)="headerEl.closeNavBar()"
					>{{ "iterlex.admin" | translate }}</a
				>
			</it-navbar-item>
		}
	</ng-container>
</it-header>
